import classnames from "classnames";
import {PropsWithChildren} from "react";

import styles from "./CallToActionBlock.module.css";

interface CallToActionBlockProps extends PropsWithChildren {
  text: string;
}
export const CallToActionBlock = ({text, children}: CallToActionBlockProps) => {
  return (
    <div
      className={classnames(
        styles.CallToActionBlock,
        "rounded rounded-3 p-4 d-flex align-items-center justify-content-between"
      )}
    >
      <div>{text}</div>
      {children}
    </div>
  );
};
